import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { InputAdornment } from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';

import { resetPasswordRequest, resendConfirmationCode, clearError } from '~/store/ducks/auth';
import { validPassword } from '~/util/validate';
import Button from '~/components/Button';

import { Input, Link, Resend } from './styles';
import history from '~/services/history';

export default function ForgotPasswordCode({ location }) {
  const [code, setCode] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [secureText, setSecureText] = useState(true);
  const [secureConfirmText, setSecureConfirmText] = useState(true);
  const [codeError, setCodeError] = useState(null);
  const [passError, setPassError] = useState(null);
  const [confirmError, setConfirmError] = useState(null);
  const { loading, error } = useSelector(state => state.auth);
  const dispatch = useDispatch();
  const username = location.state;

  useEffect(() => {
    if (error) {
      return setCodeError({
        message: error.apiError && error.apiError.message,
      });
    }
  }, [error]);

  const handleSubmit = event => {
    event.preventDefault();
    setCodeError(null);
    setPassError(null);
    setConfirmError(null);

    if (!code.trim()) {
      return setCodeError({ message: 'Código de Confirmação não informado!' });
    }

    if (!password.trim()) {
      return setPassError({ message: 'Senha não informado!' });
    }

    if (password !== confirmPassword) {
      setPassError({ message: 'Senhas não conferem!' });
      setConfirmError({ message: 'Senhas não conferem!' });
      return true;
    }

    if (!validPassword(password)) {
      return setPassError({
        message: 'Deve conter 8 caracteres. Caracter especial. Letras e números.',
      });
    }

    dispatch(resetPasswordRequest(username, password, code));
    return true;
  };

  const resendCode = () => {
    dispatch(resendConfirmationCode(username));
  };

  const goBack = () => {
    dispatch(clearError());
    history.push('/');
  };

  return (
    <form onSubmit={handleSubmit}>
      <Input
        name='code'
        label='Código de confirmação'
        value={code}
        onChange={e => setCode(e.target.value)}
        error={codeError}
        autoFocus
      />
      <Input
        name='password'
        label='Nova senha'
        type={secureText ? 'password' : 'text'}
        value={password}
        onChange={e => setPassword(e.target.value)}
        error={passError}
        InputProps={{
          endAdornment: (
            <InputAdornment
              position='end'
              onClick={() => setSecureText(secure => !secure)}
              style={{ cursor: 'pointer', color: '#fff' }}
            >
              {secureText ? <VisibilityOff /> : <Visibility />}
            </InputAdornment>
          ),
        }}
      />
      <Input
        name='password'
        label='Confirmar nova senha'
        type={secureConfirmText ? 'password' : 'text'}
        value={confirmPassword}
        onChange={e => setConfirmPassword(e.target.value)}
        error={confirmError}
        InputProps={{
          endAdornment: (
            <InputAdornment
              position='end'
              onClick={() => setSecureConfirmText(secure => !secure)}
              style={{ cursor: 'pointer', color: '#fff' }}
            >
              {secureConfirmText ? <VisibilityOff /> : <Visibility />}
            </InputAdornment>
          ),
        }}
      />

      <Button type='submit' filled label='Confirmar' loading={loading} />

      <Resend onClick={() => resendCode()}>Reenviar código de confirmação</Resend>

      <Link to='/' onClick={_ => goBack()}>
        Cancelar
      </Link>
    </form>
  );
}
